/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/templates/blog.js":
/*!***************************************!*\
  !*** ./src/scripts/templates/blog.js ***!
  \***************************************/
/***/ (() => {

eval("const dom = {};\nconst selectors = {\n  blogNavScroll: '[data-blog-nav-scroll]',\n  blogNavSelect: '[data-blog-nav-select]',\n  blogNavItem: '[data-blog-nav-item]'\n};\nconst cacheDom = () => {\n  dom.blogNavScroll = document.querySelector(selectors.blogNavScroll);\n  dom.blogNavSelect = document.querySelector(selectors.blogNavSelect);\n};\nconst bindEvents = () => {\n  dom.blogNavSelect && dom.blogNavSelect.addEventListener('change', e => {\n    const selected_option = dom.blogNavSelect.selectedOptions[0];\n    if (selected_option.dataset.newWindow) {\n      window.open(dom.blogNavSelect.value, \"_blank\");\n    } else {\n      window.location.href = dom.blogNavSelect.value;\n    }\n  });\n};\nconst init = () => {\n  if (dom.blogNavScroll) {\n    const activeItem = dom.blogNavScroll.querySelector(`${selectors.blogNavItem}.active`);\n    if (activeItem) {\n      const offsetLeft = activeItem.getBoundingClientRect().left - dom.blogNavScroll.getBoundingClientRect().left;\n      dom.blogNavScroll.scrollTo({\n        left: offsetLeft,\n        behavior: \"smooth\"\n      });\n    }\n  }\n};\ndocument.addEventListener('DOMContentLoaded', () => {\n  cacheDom();\n  init();\n  bindEvents();\n});\n\n//# sourceURL=webpack://gaia-theme/./src/scripts/templates/blog.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./src/scripts/templates/blog.js"]();
/******/ 	
/******/ })()
;